import { FC } from "react";

import TableAccess from "../../../components/table/tunder/TableAccess";

import styles from "./access.module.scss";

const Access: FC = () => {
  return (
    <div className={styles.access}>
      <TableAccess />
    </div>
  );
};

export default Access;
